import styled from '@emotion/styled';
import TableCell from '@mui/material/TableCell';

export const TableHeadCell = styled(TableCell)`
  align-items: center;
  color: ${({ theme }) => theme.color.dark2};
  font: bold normal 0.75rem/1rem ${({ theme }) => theme.font.gotham};
  text-transform: uppercase;
`;
